import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldAlert } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-brand-dark" data-id="element-63">
      {/* Background subtle elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,102,0,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-64" />
      <div className="absolute top-0 left-0 w-full h-1 bg-brand-orange" data-id="element-65" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-66">
        <div className="text-left space-y-8" data-id="element-67">
          <FadeIn delay={0.1} data-id="element-68">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-orange/10 border border-brand-orange/30 text-brand-orange text-sm font-semibold uppercase tracking-wider mb-4" data-id="element-69">
              <ShieldAlert size={16} data-id="element-70" />
              <span data-id="element-71">Sistema de Evacuación de Emergencia</span>
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-bold leading-[1.1] text-white uppercase" data-id="element-72">
              Protocolo <span className="text-brand-orange" data-id="element-73">72 Horas</span>
            </h1>
            <p className="text-2xl md:text-3xl font-display text-gray-300 mt-2 uppercase tracking-wide" data-id="element-74">
              El Método "Caja Negra" para Proteger a tu Familia en 15 Minutos
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-75">
            <p className="text-lg md:text-xl text-gray-400 leading-relaxed max-w-xl" data-id="element-76">
              No esperes a que el 911 deje de responder. Ten listo el único
              sistema de evacuación diseñado para sobrevivir al pánico, proteger
              tus documentos y mantener el control cuando el caos toque a tu
              puerta.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-77">
            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-78">
              <button type="button" className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-white uppercase tracking-widest bg-brand-orange overflow-hidden transition-all hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-brand-orange focus:ring-offset-2 focus:ring-offset-brand-dark cursor-default" data-id="element-79">
                <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-56 group-hover:h-56 opacity-10" data-id="element-80"></span>
                <span className="relative flex items-center gap-2" data-id="element-81">
                  Proteger a mi familia ahora
                  <svg className="w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-82">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-83"></path>
                  </svg>
                </span>
              </button>
            </div>
            <p className="text-sm text-gray-500 mt-4 flex items-center gap-2" data-id="element-84">
              <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-85">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-86"></path>
              </svg>
              Acceso inmediato tras la compra
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.4} direction="left" className="relative" data-id="element-87">
          <div className="relative w-full max-w-lg mx-auto" data-id="element-88">
            {/* Glow effect behind image */}
            <div className="absolute inset-0 bg-brand-orange/20 blur-3xl rounded-full transform scale-90" data-id="element-89" />
            <img src="https://cdn.magicpatterns.com/uploads/eNHZrdy6SqzupgGKrv7vfL/PROTOCOLO_72_HORAS_portada.png" alt="Protocolo 72 Horas Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-90" />
          </div>
        </FadeIn>
      </div>
    </section>;
}